import React, { FC } from 'react'

import { IconSuperWifiProps } from './IconSuperWifi.types'
import * as Styled from './styles/IconSuperWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSuperWifi: FC<IconSuperWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSuperWifiProps['size'],
  isResponsive = false,
}: IconSuperWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M12.36 10.777 5.062 18.5a1.947 1.947 0 0 0 0 2.75l17.55 17.184c.754.761 1.985.77 2.75.02l.02-.02L42.938 21.25a1.947 1.947 0 0 0 0-2.75l-7.41-7.836a1.917 1.917 0 0 0-1.387-.59H13.859c-.523 0-1.023.211-1.386.59l-.114.113Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M11.129 20.441c7.101-7.109 18.621-7.113 25.73-.015v.015'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.809 24.336c5.074-5.078 13.304-5.078 18.382 0m-14.535 3.926a7.561 7.561 0 0 1 10.688 0m-4.668 4.832a.677.677 0 1 1-1.354.005.677.677 0 0 1 1.354-.005Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m24.422 33.094-.422.422-.422-.422.422-.422.422.422Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSuperWifi
